// https://github.com/camunda-community-hub/extended-form-js
// https://github.com/camunda-community-hub/camunda-modeler-plugin-reduced-palette
import BpmnModeler from 'camunda-bpmn-js/lib/camunda-platform/Modeler';
import 'camunda-bpmn-js/dist/assets/camunda-platform-modeler.css';
import ExecutionPlatformModule from '@camunda/execution-platform';
import ModelerModdle from 'modeler-moddle/resources/modeler.json';

// https://gitlab.evolenta.ru/github/camunda/camunda-modeler-custom-linter-rules-plugin
import type Modeler from 'bpmn-js/lib/Modeler';
import LintingModule from 'bpmn-js-bpmnlint';
import 'bpmn-js-bpmnlint/dist/assets/css/bpmn-js-bpmnlint.css';
// import LintingConfig from './features/linting/.bpmnlintrc';
// import lintModule from 'bpmn-js-bpmnlint';
// import { Linter as BaseLinter } from '@camunda/linting';
// import CamundaLintingModule from '@camunda/linting/modeler';
// import '@camunda/linting/assets/linting.css';
// import('bpmnlint-plugin-camunda-compat');
// import minimapModule from 'diagram-js-minimap';
import 'bpmn-js-token-simulation/assets/css/bpmn-js-token-simulation.css';

// @ts-ignore
import LintingConfig from './preact/linting/.bpmnlintrc';
import PaletteProvider from './preact/palette-provider';
import PopupMenuProvider from './preact/popup-menu';
import PropertiesProvider from './preact/properties-provider';
import stepManModdle from './preact/step-man/step-man-schema.json';
import TranslationModule from './preact/translation';
import type { ServiceMap } from './types/didi';
import { tokens } from '@fluentui/react-components';

// "bpmn-font": "^0.12.1",
// import 'bpmn-font/dist/css/bpmn-embedded.css';

// bpmn io repos: https://github.com/orgs/bpmn-io/repositories?type=all&q=sort%3Aname-asc
// camunda repos: https://github.com/orgs/camunda/repositories?q=sort%3Aname-asc
// bpmn io awesome: https://github.com/bpmn-io/awesome-bpmn-io?tab=readme-ov-file
// bpmn io examples: https://github.com/bpmn-io/bpmn-js-examples?tab=readme-ov-file
// bpmn io (js) walkthrough: https://bpmn.io/toolkit/bpmn-js/walkthrough/
// simple lint config: https://github.com/bpmn-io/bpmn-js-bpmnlint

// https://github.com/bpmn-io/bpmn-js-properties-panel?tab=readme-ov-file
// https://github.com/bpmn-io/diagram-js-ui

export type TModeler = Modeler<ServiceMap>;

export const initModeler = (): TModeler =>
    new BpmnModeler({
        bpmnRenderer: {
            defaultFillColor: 'transparent',
            defaultStrokeColor: tokens.colorNeutralForeground1,
            defaultLabelColor: tokens.colorNeutralForeground1,
        },
        additionalModules: [
            ExecutionPlatformModule,
            LintingModule,
            // CamundaLintingModule,
            // CtxPadProvider,
            PaletteProvider,
            PopupMenuProvider,
            PropertiesProvider,
            //TokenSimulationModule,
            TranslationModule,
        ],
        executionPlatform: {
            name: 'Camunda Platform',
            version: '7.24',
        },
        linting: {
            // active: true,
            bpmnlint: LintingConfig,
        },
        moddleExtensions: {
            modeler: ModelerModdle,
            fism: stepManModdle,
        },
    });
